import { render, staticRenderFns } from "./EditInternalInfo.vue?vue&type=template&id=5bd459c8&"
import script from "./EditInternalInfo.vue?vue&type=script&lang=js&"
export * from "./EditInternalInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditInternalInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
